import { gql, useMutation } from '@apollo/client';
import { useSetRecoilState } from 'recoil';
import { Form, Formik } from 'formik';

import * as K from 'common/constants';
import Page from 'components/common/Page/Page';
import Input from 'components/common/Input/Input';
import Button, { ButtonVariant } from 'components/common/Button/Button';
import PageHeader from 'components/common/PageHeader/PageHeader';
import { pageAlertConfigState } from 'components/common/PageAlert/PageAlert.state';
import { PageAlertVariant } from 'components/common/PageAlert/PageAlert.types';

const SIGN_UP = gql`
  mutation signUpWithLoginAndPassword($emailAddress: String!, $password: String!, $clientTimeZoneOffset: String!) {
    signUpWithLoginAndPassword(
      emailAddress: $emailAddress
      password: $password
      clientTimeZoneOffset: $clientTimeZoneOffset
    )
  }
`;

/**
 * This is a sign up form used on non-prod environments (i.e. localhost, QA, Staging)
 * In production we serve { @see SignUpForm } which adds necessary Marketing integrations
 */
function SignUpPageInternal(): JSX.Element {
  const setPageAlertConfig = useSetRecoilState(pageAlertConfigState);
  const [signUp] = useMutation(SIGN_UP, {
    onCompleted: () => {
      window.location.replace(K.ROUTE.ROOT);
    },
    onError: (error) => {
      setPageAlertConfig({ variant: PageAlertVariant.ERROR, message: String(error), dismissible: true });
    },
  });

  return (
    <>
      <Page docTitle="Sign Up">
        <PageHeader title="Sign Up" />
        <Formik
          onSubmit={({ email, password }) =>
            signUp({
              variables: { emailAddress: email, password, clientTimeZoneOffset: new Date().getTimezoneOffset() },
            })
          }
          initialValues={{ email: '', password: '' }}
        >
          {({ handleChange, values, touched, errors, submitForm }): JSX.Element => (
            <Form style={{ width: 400 }}>
              <Input
                type="email"
                name="email"
                placeholder="Email address"
                value={values.email}
                onChange={handleChange}
                isInvalid={touched.email && !!errors.email}
                errorMessage={errors.email}
              />
              <Input
                type="password"
                name="password"
                placeholder="Password"
                onChange={handleChange}
                value={values.password}
                isInvalid={touched.password && !!errors.password}
                errorMessage={errors.password}
              />
              <Button
                variant={ButtonVariant.PRIMARY}
                onClick={submitForm}
                style={{ justifyContent: 'center', float: 'right' }}
              >
                Sign Up
              </Button>
            </Form>
          )}
        </Formik>
      </Page>
    </>
  );
}

export default SignUpPageInternal;
